export default "__VITE_ASSET__2H$QPdLk__"